export default __webpack_public_path__ + "static/media/church_300.70fb0c56.webp";